var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 31,
    viewBox: "0 0 48 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5879 2.81641H0V28.1497H47.5879V2.81641Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0188 3.2462e-07C41.6394 5.66923e-07 16.4478 -5.14526e-07 2.37939 3.2462e-07C1.1897 3.95583e-07 0 1.28376 0 2.56752V6.4188H47.5879C47.5879 6.4188 47.5879 12.3793 47.5879 3.85128C47.5879 1.28376 46.3982 3.2462e-07 44.0188 3.2462e-07Z",
    fill: "#265697"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 25.334C0 25.334 2.87423e-07 25.334 0 27.5858C-1.3766e-07 29.8377 1.1897 30.9636 3.56909 30.9636C16.8411 30.9636 41.6394 30.9636 44.0188 30.9636C46.3982 30.9636 47.5879 29.8377 47.5879 27.5858V25.334H0Z",
    fill: "#D97B16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6348 9.01602C32.0063 8.73979 31.0217 8.44336 29.792 8.44336C26.6579 8.44336 24.4502 10.2927 24.4314 12.943C24.4137 14.9022 26.0075 15.9951 27.2106 16.6473C28.4452 17.3156 28.8603 17.7419 28.8543 18.3386C28.8465 19.2526 27.8684 19.6701 26.9568 19.6701C25.6872 19.6701 25.0128 19.4635 23.9711 18.9544L23.5624 18.7377L23.1172 21.79C23.858 22.1706 25.228 22.5003 26.6504 22.5174C29.9845 22.5174 32.149 20.6893 32.1736 17.8591C32.1855 16.308 31.3404 15.1276 29.5106 14.1546C28.4019 13.5238 27.7229 13.1029 27.7301 12.4642C27.7301 11.8975 28.3048 11.2915 29.5465 11.2915C30.5838 11.2726 31.3351 11.5376 31.9205 11.8138L32.2047 11.9712L32.6348 9.01602Z",
    fill: "#265697"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1076 8.44336H39.4744C38.6587 8.44336 38.0482 8.66906 37.69 9.49444L32.6289 21.11H36.2074C36.2074 21.11 36.7924 19.5482 36.9248 19.2053C37.3158 19.2053 40.7921 19.2108 41.2891 19.2108C41.3911 19.6545 41.7037 21.11 41.7037 21.11H44.8658L42.1076 8.44336ZM37.9055 16.6128C38.1873 15.8826 39.2632 13.0697 39.2632 13.0697C39.2431 13.1034 39.5429 12.3359 39.715 11.86L39.9453 12.9528C39.9453 12.9528 40.5979 15.9783 40.7343 16.6127L37.9055 16.6128Z",
    fill: "#265697"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6758 21.11L19.768 8.44336H23.1144L21.0207 21.11H17.6758Z",
    fill: "#265697"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3592 8.44336L11.963 17.0949L11.6012 15.3367C10.9689 13.31 8.99908 11.1141 6.79688 10.0147L9.90229 21.11L13.5725 21.1059L19.0338 8.44336H15.3592Z",
    fill: "#265697"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18078 8.44336H2.76552L2.72266 8.71252C6.93568 9.78333 9.7234 12.3711 10.8806 15.4804L9.70307 9.53552C9.49978 8.71635 8.91017 8.47191 8.18078 8.44336Z",
    fill: "#D97B16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaImage);
export default __webpack_public_path__ + "static/media/visa_image.566bd4006061d0881ef3889f80b81afb.svg";
export { ForwardRef as ReactComponent };